import script from "./WYSIWYG.vue?vue&type=script&lang=ts&setup=true"
export * from "./WYSIWYG.vue?vue&type=script&lang=ts&setup=true"

import "./WYSIWYG.vue?vue&type=style&index=0&id=4f9aa1ae&scoped=true&lang=css"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f9aa1ae"]])

export default __exports__